<template>
<v-layout column>
	<v-flex justify-center class="app-footer">
		<v-layout class="column-responsive" row xs12 align-center>
			<v-layout column text-xs-center>
				<v-flex>
					<a href="/">
						<img src="https://web-apprunn.s3-sa-east-1.amazonaws.com/logo-apprunn.svg" alt="" class="logo-apprunn">
					</a>
				</v-flex>
				<v-flex>
					<v-flex align-center class="company-logos">
						<div class="item-company" v-for="(item, index) in logosCompany" :key="index">
							<img :style="`width: ${item.width}`" :src="item.logo" alt="">
						</div>
					</v-flex>
				</v-flex>
			</v-layout>
			<v-layout class="content-links">
				<v-flex class="links-footer" column v-for="(item, index) in linksFooter" :key="index">
					<p class="title-footer">{{ item.name }}</p>
					<v-layout class="item-footer" v-for="(link, index) in item.items" :key="index">
						<a class="item-link" :href="link.href">
							{{ link.name }}
						</a>
					</v-layout>
				</v-flex>
			</v-layout>
		</v-layout>
	</v-flex>
	<v-flex text-xs-center class="reserved">
		<v-layout :class="windowSize.x < 1024 ? 'section-links-networks' : 'desktop-link-responsive'" justify-center row align-center>
			<v-flex v-for="(icon, index) in links" :key="index" class="border-right">
				<a :href="icon.link">
					<img :src="icon.icon" alt="" :style="`width: ${icon.width}px`">
				</a>
			</v-flex>
		</v-layout>
		©2020 Derechos reservado Apprunn
	</v-flex>
</v-layout>
</template>

<script>
function data() {
	return {
		links: [
			{
				id: 1,
				name: 'facebook',
				link: 'https://es-la.facebook.com/apprunn/',
				icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/facebook+(1).svg',
				width: 15,
			},
			{
				id: 2,
				name: 'instagram',
				link: 'https://www.instagram.com/apprunn/?igshid=1qlz6flo9sst4',
				icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/instagram-sketched.svg',
				width: 19,
			},
			{
				id: 3,
				name: 'linkedin',
				icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/linkedin+(1).svg',
				link: 'https://www.linkedin.com/company/apprunn',
				width: 19,
			},
			{
				id: 4,
				name: 'youtube',
				link: 'https://www.youtube.com/channel/UCXfyVSRRJbBL1bUGbRqJCSA?disable_polymer=true&nv=1',
				width: 14,
				icon: 'https://web-apprunn.s3-sa-east-1.amazonaws.com/play+(2).svg',
			},
		],
	};
}

export default {
	name: 'app-footer',
	data,
	props: {
		logosCompany: {
			type: Array,
			default: () => [],
		},
		linksFooter: {
			type: Array,
			default: () => [],
		},
		windowSize: {
			type: Object,
			default: () => {},
		},
	},
};
</script>

<style lang="scss" scoped>
.app-footer {
	background-color: map-get($colors, regular);
	height: 514px;
	padding-top: 66px;

	@media (max-width: 1024px) {
		height: 1125px;
		padding-top: 110px;
	}
}

.title-footer {
	color: map-get($colors, white);
	font-family: 'Lato', sans-serif;
	font-weight: bold;
	font-size: map-get($sizes, large);
	margin-bottom: 35px;

	@media (max-width: 960px) {
		text-align: center;
	}
}

.item-footer {
	color: map-get($colors, white);
	font-family: 'Lato', sans-serif;
	font-weight: 400;
	font-size: map-get($sizes, large);
	margin-bottom: 30px;

	@media (max-width: 1024px) {
		justify-content: center;
	}
}

.content-links {
	display: grid;
	grid-template-columns: auto auto;
	position: relative;
	top: 120px;

	@media (max-width: 960px) {
		grid-template-columns: auto;
	}
}

.reserved {
	background-color: map-get($colors, base);
	color: map-get($colors, white);
	font-family: 'Lato', sans-serif;
	font-weight: 400;
	font-size: map-get($sizes, medium);
	padding: 15px 0;
	position: relative;
}

.item-link {
	color: map-get($colors, white);
	text-align: center;
	text-decoration: none;
	margin: 0;
}

.company-logos {
	display: grid;
	grid-template-columns: auto auto auto;
	grid-column-gap: 100px;
	grid-row-gap: 50px;
	justify-content: center;
	margin-top: 71px;

	@media (max-width: 960px) {
		grid-template-columns: auto auto;
		grid-column-gap: 29px;
	}
}

.item-company {
	opacity: 0.43;

	&:hover {
		transform: scale(1.1);
		transition:all 0.3s ease-out 0s;
		opacity: 1;	
	}

	@media (max-width: 1024px) {
		opacity: 1;
		transform: none !important;
	}
}

.item-company:nth-child(7) {
	grid-column: 2 / 3;

	@media (max-width: 960px) {
		grid-column: 1 / 3;
	}
}

.column-responsive {
	@media (max-width: 1024px) {
		flex-direction: column;
		padding-bottom: 55px;
	}
}

.logo-apprunn {
	@media (max-width: 960px) {
		width: 128px;
	}
}

.links-footer:nth-child(1) {
	margin-bottom: 54px;
}

.text-decoration-none {
	text-decoration: none;
}

.section-links-networks {
	background-color: map-get($colors, base);
	border-top-left-radius: 9px;
	border-top-right-radius: 9px;
	bottom: 45px;
	left: 50%;
	padding: 9px 0;
	position: absolute;
	transform: translateX(-50%);
	width: 200px;
}

.border-right {
	border-right: 1px solid white;

	&:last-child {
		border-right: none !important;
	}
}

.desktop-link-responsive {
	display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/home/app-footer.vue